import React from 'react';
import { BookOpen, Brain, Users, FileText, Calculator, Heart } from 'lucide-react';
const tomos = [{
  id: 1,
  title: 'TOMO 1 — Evaluación Psicopedagógica (ARG)',
  desc: 'Anamnesis, entrevistas, EOCA, registros, seguimiento e informes.',
  icon: FileText,
  color: 'bg-blue-100 text-blue-600'
}, {
  id: 2,
  title: 'TOMO 2 — TDA / TDAH',
  desc: 'Estrategias, adaptaciones y actividades de atención/autorregulación.',
  icon: Brain,
  color: 'bg-red-100 text-red-600'
}, {
  id: 3,
  title: 'TOMO 3 — TEA (Autismo) e inclusión',
  desc: 'Rutinas, apoyos visuales, comunicación y trabajo escuela–familia.',
  icon: Users,
  color: 'bg-green-100 text-green-600'
}, {
  id: 4,
  title: 'TOMO 4 — Dislexia',
  desc: 'Secuencias y fichas para lectura, fluidez, comprensión y escritura.',
  icon: BookOpen,
  color: 'bg-purple-100 text-purple-600'
}, {
  id: 5,
  title: 'TOMO 5 — Discalculia / Matemática',
  desc: 'Sentido numérico, cálculo, problemas y juegos.',
  icon: Calculator,
  color: 'bg-orange-100 text-orange-600'
}, {
  id: 6,
  title: 'TOMO 6 — Psicomotricidad + Socioemocional',
  desc: 'Motricidad fina/gruesa, regulación emocional y habilidades sociales.',
  icon: Heart,
  color: 'bg-pink-100 text-pink-600'
}];
export function WhatIncludesSection() {
  return <section id="que-incluye" className="py-16 md:py-24 px-4 bg-orange-100/30 border-y border-orange-200/40" data-id="element-137">
      <div className="max-w-6xl mx-auto" data-id="element-138">
        <h2 className="text-4xl md:text-5xl font-black text-center text-gray-900 mb-16 uppercase" data-id="element-139">
          ¿Qué incluye?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-140">
          {tomos.map(tomo => <div key={tomo.id} className="bg-white/70 backdrop-blur-sm p-8 rounded-2xl shadow-lg border border-orange-100/50 hover:shadow-xl transition-shadow" data-id="element-141">
              <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 ${tomo.color}`} data-id="element-142">
                <tomo.icon className="w-8 h-8" data-id="element-143" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 leading-tight" data-id="element-144">
                {tomo.title}
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-145">
                {tomo.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}